export const convertChartAnalysis = (input) => {
  let output = [];
  for (var i in input) {
    output.push({ name: i, value: input[i] });
  }
  return output;
};
